import type { SuggestedRateView } from "@/schemas/resource-internal-rates";

/** `2026-04` → `Apr 2026`. */
export function formatRateMonth(month: string): string {
  const [y, m] = month.split("-");
  const d = new Date(Date.UTC(Number(y), Number(m) - 1, 1));
  return d.toLocaleDateString("en-US", { month: "short", year: "numeric", timeZone: "UTC" });
}

export function describeSuggestion(s: SuggestedRateView): string {
  if (s.kind === "suggested") {
    return `${s.laborCategoryName} cost — strongest confirmed Discipline: ${s.disciplineCode}, rated ${s.rating}`;
  }
  return s.reason === "no_confirmed_rating"
    ? "No confirmed Discipline rating yet, so there is nothing to suggest."
    : `${s.disciplineCode ?? "Their strongest Discipline"} has no default Labor Category to take a cost from.`;
}
